var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup',{attrs:{"title":("מצטערים, המערכת לא תומכת כרגע ב" + (_vm.source.displayName) + "..."),"close-action":_vm.popupClosed,"buttons":[
  {
    title: 'זה החשבון העיקרי שלי',
    subtitle: 'תעדכנו אותי כשתתמכו',
    action: _vm.primaryBankSelected,
    variant: 'primary',
  },
  {
    title: 'זה לא החשבון העיקרי',
    subtitle: 'אני רוצה להמשיך בלעדיו',
    action: _vm.continueWithoutSelected,
    variant: 'primary',
  } ]}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7db3fd2c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/unsupported-banks/UnsupportedBanksDecisionPopup.vue
// module id = null
// module chunks = 